<!--
Copyright (C) Cocouz Oy 2017 - All Rights Reserved
-->
<template>
  <div class="header__container">
    <div class="header__buttons">
      <div v-show="!hidePhotos"  @click="openGallery(0)" class="header__button button button--white button--small">{{ strings.viewPhotos }}</div>
      <a v-show="getThreeSixty" href="#" @click="show360Modal = true" class="header__button button button--white button--small">{{ strings.view }} 360°</a>
      <a v-show="venueVideoLink" href="#" @click="showModal = true" class="header__button button button--white button--small">{{ strings.viewvideo }}</a>
    </div>

    <lightbox
          :images="images"
          ref="lightbox"
          :showLightBox="false"
          :show-caption="false"
     ></lightbox>
    <div id="video__container">
      <ModalComponent v-if="showModal" @close="showModal = false">
        <div slot="header"></div>
        <div slot="body" id="videoModalBody">
          <span v-html="venueVideoLink"></span>
        </div>
        <div slot="footer">
          <button style="background-color: #0055a9;" type="button" title="Close (Esc)" class="modal-default-button vue-lb-button-close" @click="showModal = false">
                    <span>
                      <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
                        <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"></path>
                      </svg>
                    </span>
          </button>
        </div>
      </ModalComponent>
    </div>
    <div id="video__container_360">
      <ModalComponent v-if="show360Modal" @close="show360Modal = false">
        <div slot="header"></div>
        <div slot="body" id="video360ModalBody">
          <div style="margin:0px;padding:0px;overflow:hidden">
              <iframe :src="getThreeSixty" frameborder="0" style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:150%;width:150%;position:absolute;top:0px;left:0px;right:0px;bottom:0px" height="150%" width="150%"></iframe>
          </div>
        </div>
        <div slot="footer">
          <button style="background-color: #0055a9;" type="button" title="Close (Esc)" class="modal-default-button vue-lb-button-close" @click="show360Modal = false">
                    <span>
                      <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
                        <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"></path>
                      </svg>
                    </span>
          </button>
        </div>
      </ModalComponent>
    </div>
  

  <!--modal-->
  </div>
</template>



<script>
  import Lightbox from 'vue-image-lightbox';
  import ModalComponent from './ModalComponent';

  export default {
    name: 'MPGalleryButtons',
    components: {
      Lightbox,
      ModalComponent
    },

    data () {
      return {
        images: [],
        baseUrl: '',
        baseStyles: [],
        someImages: [],
        showModal: false,
        show360Modal: false,

      }
    },
    methods: {

      openGallery: function(index) {

        let allImages;
        this.images = [];
        for (let i=0; i <  this.$store.state.getImages.length; i++) {
          allImages = {
            thumb: this.$store.state.getImages[i],
            src: this.$store.state.getImages[i],
          }
          this.images.push(allImages);
        }

        if (this.$store.state.getImages.length != 0) {
          this.$refs.lightbox.showImage(index);
        }
      },
    },
    computed: {
      hidePhotos() {
        if (this.$store.state.getImages.length == 0) {
          return true;
        } else {
          return false;
        }
      },
      getThreeSixty() {
        return this.$store.state.getThreeSixty;
      },
      venueVideoLink() {
        return this.$store.state.venueVideoLink;
      },
      strings () {
	      return this.$store.state.strings
      },
    }
  }
</script>
<style scoped>
  #videoModalBody iframe {
    width: 100%!important;
    position: inherit!important;
    top: 0px!important;
    height: 100%!important;
  }
  #video__container .modal-body, #video__container_360 .modal-body  {
    margin: 0px!important;
    height: 400px!important;
  }
  #video__container, #videoModalBody, #video__container_360{
    height: 100%;
  }
  #video__container .modal-container, #video__container_360 .modal-container{
    width: 800px;
    height:485px!important;
  }
  @media screen and (max-width: 830px) {
    #video__container .modal-container, #video__container_360 .modal-container{
      width: 100%!important;
    }
  }
  .header__button {
    margin-right: 7px
  }
</style>
<style>
  #videoModalBody iframe {
    width: 100%!important;
    position: inherit!important;
    top: 0px!important;
    height: 100%!important;
  }
  #video__container .modal-body, #video__container_360 .modal-body  {
     margin: 0px!important;
    height: 400px!important;
  }
  #video__container, #videoModalBody, #video__container_360{
    height: 100%;
  }
  #video__container .vue-lb-button-close, #video__container_360 .vue-lb-button-close{
    top:10px!important;
    margin-bottom: 0px!important;
  }
  #video__container .modal-container, #video__container_360 .modal-container{
    width: 800px;
    height:485px!important;
  }
  @media screen and (max-width: 830px) {
    #video__container .modal-container, #video__container_360 .modal-container{
      width: 100%!important;
    }
  }
</style>